export default __webpack_public_path__ + "media/images/banners/bnr_saiyoritsu_up-819e16f8333e13768fa758aff352fa2b.jpg";